import { FC, ReactNode } from "react";

import { Collapse as MuiCollapse } from "@mui/material";

import { shouldAnimate } from "../../styles";

export const Collapse: FC<{
  open: boolean;
  children: ReactNode;
  shouldAnimate?: boolean;
}> = ({ open, children, shouldAnimate: shouldAnimateProp = shouldAnimate }) => {
  if (shouldAnimateProp) {
    return (
      <MuiCollapse in={open} timeout="auto" unmountOnExit>
        {children}
      </MuiCollapse>
    );
  } else {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{open && children}</>;
  }
};
